<template>
<div>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-card style="position: relative;top: 120px;left: -20px">
          <div class="chart-container" id="line"></div>
        </el-card>
      </el-col>
      <el-col :span="0">
        <el-card style="position: relative;top: 100px;">
          <div style="width: 100%;height: 400px" id="bing"></div>
        </el-card>
      </el-col>
    </el-row>
</div>
</template>

<script>
import axios from "axios";
import * as echarts from 'echarts';


export default {
  name: "ECharts",
  data(){
    return{
      intervalId: null,
      option : {
        title: {
          text: '温湿度实时折线图'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['湿度', '温度'],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        //下载
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          reverse:false,
          data: [],
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '湿度',
            type: 'line',
            stack: 'Total',
            data: []
          },
          {
            name: '温度',
            type: 'line',
            data: [],
          },
        ]
      },
      option1 : {
        title: {
          text: '消费原型图',
          subtext: '原型图',
          left: 'center'
        },
        tooltip: {
          formatter: function (params) {
            return params.seriesName + '<br/>' + params.name + ': ' + params.value + '%';
          }
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '消费额',
            type: 'pie',
            radius: '60%',
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
    }
  },
  async mounted() {
    await this.loadLineChart();
  },
  beforeDestroy() {
    this.loadLineChart();
  },
  methods:{
     async loadLineChart(){
       this.intervalId = setInterval(async () =>{
         try {
         let lineDom  = document.getElementById("line");
       let lineChart = echarts.init(lineDom);
       //let bingDom  = document.getElementById("bing");
       //let bingChart = echarts.init(bingDom);
       //let res = await axios.get('/api/Transactions/eCharts');
       let res1 = await axios.get('/otherApi/test/');
       //console.log(res)
       console.log(res1)
       //this.option.xAxis.data=res.data.data.line.map(v => v.date);
       //this.option.series[0].data=res.data.data.line.map(v => v.value);
           function formatTimestampTo24Hour(timestamp) {
             // 创建一个新的Date对象
             const date = new Date(timestamp);
             // 转换为24小时制时间字符串
             // 注意：这里的`hour12: false`选项强制使用24小时制
             const timeString = new Intl.DateTimeFormat('en-US', {
               hour12: false,
               hour: '2-digit',
               minute: '2-digit',
               timeZone: 'UTC' // 指定时区
             }).format(date);
             return timeString;
           }
       this.option.xAxis.data=res1.data.data.map(v => formatTimestampTo24Hour(v.timestamp));
       this.option.series[0].data = res1.data.data.map(v => v.measurements.humidity)
       this.option.series[1].data = res1.data.data.map(v => v.measurements.temperature)
       lineChart.setOption(this.option)
         } catch (error) {
           console.error('Polling error:', error);
         }
       }, 3000);
       /*this.option1.series[0].data=res.data.data.bar
       bingChart.setOption(this.option1)*/
     },
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%; /* 或者你想要的任何百分比 */
  height: 500px; /* 或者任何固定的高度 */
}
</style>



// WEBPACK FOOTER //
// src/components/ECharts.vue